<h1 mat-dialog-title>SOSTITUISCI ED ARCHIVIA PROFILO<mat-icon class="close-icon" (click)="onClose()">close</mat-icon></h1>
<div mat-dialog-content>
  <h1 class="bg-warning p-15">
    <span *ngIf="data.toReallocate; else toArchiveTitile">
      RICOLLOCARE il  PROFILO:
      {{existingProfileCode}} - {{existingProfileName}} vecchio dall' area {{duplicatedProposal?.profilo?.descrizioneArea?.descrizione}}
      con il nuovo:
      {{codiceProfilo}} - {{newProfile?.nomeProfilo}} nuovo  all' area {{newProfile?.descrizioneArea?.descrizione}}?</span>
    <ng-template #toArchiveTitile>
      <span >SOSTITUIRE e ARCHIVIARE il PRECEDENTE PROFILO: {{existingProfileCode}} - {{existingProfileName}} ?</span>
    </ng-template>
  </h1>

  <div class="mb-15">
    <div class="mt-15 half-width">
      <h2 class="title-heading black">Profilo da archiviare</h2>
      <mat-form-field class="full-width">
        <mat-label>ID</mat-label>
        <input matInput [value]="duplicatedProposal?.profilo?.idProfilo" readonly>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Codice profilo</mat-label>
        <input matInput [value]="duplicatedProposal?.profilo?.codiceProfilo" readonly>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Nome profilo</mat-label>
        <input matInput [value]="duplicatedProposal?.profilo?.nomeProfilo" readonly>
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Descrizione</mat-label>
        <textarea
          rows="5"
          matInput
          placeholder="Descrizione"
          [value]="duplicatedProposal?.profilo?.descrizioneProfilo"
          name="descrizione"
          readonly
        ></textarea>
      </mat-form-field>
    </div>

    <div class="mt-15 half-width">
      <h2 class="title-heading black">Profilo nuovo</h2>
      <mat-form-field class="full-width">
        <mat-label>ID</mat-label>
        <input matInput [value]="newProfile?.idProfilo" >
      </mat-form-field>
      <mat-form-field class="full-width">
        <mat-label>Codice profilo</mat-label>
        <input matInput [value]="codiceProfilo" >
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Nome profilo</mat-label>
        <input matInput [value]="newProfile?.nomeProfilo" >
      </mat-form-field>

      <mat-form-field class="full-width">
        <mat-label>Descrizione</mat-label>
        <textarea
          rows="5"
          matInput
          placeholder="Descrizione"
          [value]="newProfile?.descrizioneProfilo"
          name="descrizione"

        ></textarea>
      </mat-form-field>

    </div>
  </div>

</div>

<div mat-dialog-actions class="actions mt-15">
  <button mat-fab extended class="searchbox-buttons back-button" (click)="reject()">
    <mat-icon>arrow_back</mat-icon>
    Indietro
  </button>

  <button color="primary" mat-fab extended class="searchbox-buttons" (click)="replaceAndArchive()">
    <mat-icon>swap_horiz</mat-icon>
    Procedi
  </button>
</div>
